import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from '@chakra-ui/react'
import React from 'react'

export function DeleteBlogPostModal ({ isOpen, onClose, onDelete, isLoading }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure you want to delete this blog post?</Text>
          <Text fontSize='sm' color='red.500' mt={2}>
            This action cannot be undone.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='red' onClick={onDelete} isLoading={isLoading}>
            Delete
          </Button>
          <Button colorScheme='gray' ml={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

